import Loading from "shared/components/Spin";
import { TEMPLATES } from "utils/constants";
import CollectionNeeds from "./CollectionNeeds";
import Comparison from "./Comparison";
import Contact from "./Contact";
import Contract from "./Contract";
import Default from "./Default";
import Quote from "./Quote";
import SelectProducts from "./SelectProducts";

const Templates = {
  Loading: Loading,
  [TEMPLATES.B2B.THEMES.B2B_MILTIS.CONTACT]: Contact,
  [TEMPLATES.B2B.THEMES.B2B_MILTIS.CONTRACT]: Contract,
  [TEMPLATES.B2B.THEMES.B2B_MILTIS.QUOTE]: Quote,
  [TEMPLATES.B2B.THEMES.B2B_MILTIS.COLLECTION_NEEDS]: CollectionNeeds,
  [TEMPLATES.B2B.THEMES.B2B_MILTIS.SELECT_PRODUCTS]: SelectProducts,
  [TEMPLATES.B2B.THEMES.B2B_MILTIS.COMPARISON]: Comparison,
  default: Default,
};
export default Templates;
